export const notReachable = (_: never): never => {
  throw Error(`${_} should not be reached`)
}
